var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isButtonVisible)?_c('div',{staticClass:"event-chat"},[(_vm.isDialogVisible)?_c('event-chat-dialog',{on:{"close":_vm.onDialogClose}}):_vm._e(),_c('event-chat-button',{on:{"click":_vm.onEventChatButtonClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }